/**
 * GraphQL Queries for Deployment API
 */

/**
 * Query to fetch edited metadata items (uncommitted files)
 */
export const EDITED_METADATA_ITEMS_QUERY = `
  query EditedMetadataItems(
    $organizationId: ID!
    $isEdited: Boolean
    $first: Int
    $after: String
    $retrievalId: ID!
  ) {
    editedMetadataItems(
      organizationId: $organizationId
      isEdited: $isEdited
      first: $first
      after: $after
      retrievalId: $retrievalId
    ) {
      edges {
        node {
          id
          metadataType
          fullName
          fileName
          content
          sha256Hash
          toolingEnriched
          insertedAt
          updatedAt
          organization {
            id
            orgName
          }
          metadataRetrieval {
            id
            status
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * Query to list metadata deployments (for Success/Failed tabs)
 * Note: retrievalId is NOT required for this query
 */
export const METADATA_DEPLOYMENTS_QUERY = `
  query MetadataDeployments($organizationId: ID!, $status: DeploymentStatus) {
    metadataDeployments(organizationId: $organizationId, status: $status) {
      id
      status
      asyncProcessId
      errorMessage
      startedAt
      completedAt
      insertedAt
      updatedAt
      organization {
        id
        orgName
      }
      metadataItems {
        id
        metadataType
        fullName
        fileName
        content
      }
    }
  }
`;

/**
 * Query to get a single metadata deployment
 */
export const METADATA_DEPLOYMENT_QUERY = `
  query MetadataDeployment($id: ID, $organizationId: ID, $status: DeploymentStatus) {
    metadataDeployment(id: $id, organizationId: $organizationId, status: $status) {
      id
      status
      asyncProcessId
      deployOptions
      resultDetails
      errorMessage
      startedAt
      completedAt
      insertedAt
      updatedAt
      organization {
        id
        orgName
      }
      metadataItems {
        id
        metadataType
        fullName
        fileName
      }
    }
  }
`;

/**
 * Query to check if a metadata item has been updated (for file diff)
 */
export const CHECK_METADATA_ITEM_UPDATE_QUERY = `
  query CheckMetadataItemUpdate($metadataItemId: ID!, $organizationId: ID) {
    checkMetadataItemUpdate(metadataItemId: $metadataItemId, organizationId: $organizationId) {
      hasChanges
      localContent
      remoteContent
      metadataType
      fullName
      diff {
        type
        content
        oldLineNumber
        newLineNumber
      }
    }
  }
`;
